import { inject, Injectable } from '@angular/core';
import { FeedbackService } from './feedback.service';

@Injectable({
  providedIn: 'root'
})
export class NPSService {
  private readonly feedbackService = inject(FeedbackService);

  // Track which requests have been prompted for NPS
  private promptedRequests = new Set<string>();

  /**
   * Check if we should show NPS survey for this request
   * Only show once per request, and only if not already rated
   */
  async shouldShowNPSSurvey(requestId: string): Promise<boolean> {
    // Don't show if already prompted in this session
    if (this.promptedRequests.has(requestId)) {
      return false;
    }

    // Check if user has already rated this request
    const hasRated = await this.feedbackService.hasUserRatedRequest(requestId);
    
    if (!hasRated) {
      this.promptedRequests.add(requestId);
      return true;
    }

    return false;
  }

  /**
   * Submit NPS rating
   */
  async submitRating(requestId: string, caseId: string, rating: number, comment?: string): Promise<boolean> {
    return await this.feedbackService.submitNPSRating({
      request: requestId,
      case: caseId,
      rating,
      comment
    });
  }

  /**
   * Mark request as prompted (without rating)
   */
  markAsPrompted(requestId: string) {
    this.promptedRequests.add(requestId);
  }

  /**
   * Clear prompted requests (useful for testing or logout)
   */
  clearPromptedRequests() {
    this.promptedRequests.clear();
  }
}

